import { MdChecklistRtl } from "react-icons/md";
import { ImProfile } from "react-icons/im";
import { BsBarChartLine, BsListCheck } from "react-icons/bs";
import { AiOutlineOrderedList, AiOutlineInteraction } from "react-icons/ai";
import { CgRowFirst, CgPlayListRemove, CgUserList } from "react-icons/cg";
import { FcDeleteDatabase } from "react-icons/fc";
import { TiThSmallOutline } from "react-icons/ti";
import { FiUsers } from "react-icons/fi";
export const reportingData = [
  {
    id: "1",
    name: "مشتریان بدون فاکتور",
    path: "/dashboard/crm/reporting/Invoicelesscustomers",
    icon: <ImProfile size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "گزارشگیری",
    path: "/dashboard/crm/reporting/marker",
    icon: <BsBarChartLine size={25} />,
    color: "#13b374",
    type: "menu",
  },
  {
    id: "3",
    name: "معاملات بر اساس اشخاص",
    path: "/dashboard/crm/reporting/Transactionsbasedonpersons",
    icon: <AiOutlineOrderedList size={25} />,
    color: "#e02f87",
    type: "menu",
  },
  {
    id: "4",
    name: "معاملات",
    path: "/dashboard/crm/reporting/tradinglist",
    icon: <MdChecklistRtl size={25} />,
    color: "#ff0000",
    type: "menu",
  },
  {
    id: "5",
    name: "فرصت ها و فعالیت های امروز",
    path: "/dashboard/crm/reporting/todayactivities",
    icon: <AiOutlineInteraction size={25} />,
    color: "#ff974a",
    type: "menu",
  },

  {
    id: "7",
    name: "فعالیت های امروز انجام شده",
    path: "/dashboard/crm/reporting/activitiesdonetoday",
    icon: <BsListCheck size={25} />,
    color: "#0062FF",
    type: "menu",
  },

  {
    id: "8",
    name: "ثبت نامی های سایت",
    path: "/dashboard/crm/reporting/firstfiles",
    icon: <CgRowFirst size={25} />,
    color: "#e02f87",
    type: "menu",
  },
  {
    id: "9",
    name: "کل فرصت ها و فعالیت ها",
    path: "/dashboard/crm/reporting/allActivityAndChances",
    icon: <TiThSmallOutline size={25} />,
    color: "#030c30",
    type: "menu",
  },
  {
    id: "10",
    name: "فعالیت های گذشته",
    path: "/dashboard/crm/reporting/passedActivities",
    icon: <CgPlayListRemove size={25} />,
    color: "#e02f87",
    type: "menu",
  },
  {
    id: "11",
    name: "سرنخ های بدون فعالیت",
    path: "/dashboard/crm/reporting/CluesWithoutActivity",
    icon: <CgUserList size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "12",
    name: "مشتری های بدون فعالیت",
    path: "/dashboard/crm/reporting/CustomersWithoutActivity",
    icon: <CgUserList size={25} />,
    color: "#ff0000",
    type: "menu",
  },
  {
    id: "13",
    name: "پرونده های حذف شده",
    path: "/dashboard/crm/reporting/DeletedFiles",
    icon: <FcDeleteDatabase size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "14",
    name: "کل کاربران",
    path: "/dashboard/crm/reporting/UsersList",
    icon: <FiUsers size={25} />,
    color: "#0062FF",
    type: "menu",
  },
];
